/* eslint-disable */

import React, { useState } from "react";
import { motion } from "framer-motion";

import Image from "../image/Image.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../raindrop-button/raindrop-button.tsx";
import Spacer from "../spacer/spacer";
import TimeAgo from "../time-ago/time-ago.tsx";
import WaterfallIcon from "../waterfall-icon/waterfall-icon.tsx";
import { Link, useNavigate } from "react-router-dom";
import { fetchGraphQL } from "../../services/api-raindrop.js";

import WrapperDoubleClickable from "../wrapper-double-clickable/wrapper-double-clickable.tsx";
import RaindropCard from "../raindrop-card/raindrop-card.tsx";
import RaindropClickable from "../raindrop-clickable/raindrop-clickable.tsx";
import RaindropTextParagraph from "../raindrop-text-paragraph/raindrop-text-paragraph.tsx";
import RaindropTextSubtitle from "../raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import RaindropTextHeading1 from "../raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import AccountAvatar from "../account-avatar/account-avatar.tsx";
import FlexRow from "../flex-row/flex-row.tsx";
import FlexCol from "../flex-col/flex-col.tsx";
import { isLocalEnvironment } from "../../services/environment.js";

const LikedHeart = () => {
  return (
    <motion.div
      initial={{ opacity: 0, translateY: 20 }}
      animate={{ opacity: [0, 0.8, 0], translateY: [20, 0, -20] }}
      transition={{ duration: 1, type: "linear", bounce: 0.5 }}
      className="absolute w-full"
    >
      <i className="fas fa-heart text-color-raindrop-primary text-8xl"></i>
    </motion.div>
  );
};

const WaterfallHeader = ({
  waterfallTitle,
  urlActivity,
  urlUser,
  urlOrganisation,
  username,
  accountId,
  createdAt,
  waterfallId,
  isLinkToWaterfall = true,
}) => {
  const navigate = useNavigate();
  return (
    <RaindropClickable
      isDisabled={!isLinkToWaterfall}
      onClick={() => {
        navigate(`/raindrop/waterfall/${waterfallId}`);
      }}
    >
      <FlexRow className="gap-4">
        <WaterfallIcon
          username={username}
          urlUser={urlUser}
          urlActivity={urlActivity}
          urlOrganisation={urlOrganisation}
        />

        <div className="flex flex-col w-full text-left">
          <RaindropTextHeading1>{waterfallTitle}</RaindropTextHeading1>
          <RaindropTextSubtitle>
            <FlexRow>
              <RaindropTextSubtitle>{username}</RaindropTextSubtitle>
              <RaindropTextSubtitle>•</RaindropTextSubtitle>
              <RaindropTextSubtitle>
                <TimeAgo dateStr={createdAt} />
              </RaindropTextSubtitle>
            </FlexRow>
          </RaindropTextSubtitle>
        </div>
      </FlexRow>
    </RaindropClickable>
  );
};

const WaterfallDescription = ({ activityDescription }) => {
  return (
    <div className="bg-color-background-primary dark:bg-color-dark-background-tertiary p-2 px-4 rounded-xl">
      <RaindropTextParagraph>{activityDescription}</RaindropTextParagraph>
    </div>
  );
};

const WaterfallMedia = ({
  urlActivity,
  hasJustLiked,
  onClickLike,
  setCurrentModalComponent = (x) => {},
}) => {
  return (
    <WrapperDoubleClickable onDoubleClick={onClickLike}>
      <div className={`flex flex-row relative rounded-lg gap-4 `}>
        <RaindropClickable
          onClick={() => {
            setCurrentModalComponent(
              <img
                src={urlActivity}
                className="h-80 aspect-auto rounded-lg border dark:border-color-dark-border-secondary border-color-border-secondary"
              />
            );
          }}
        >
          <Image
            src={urlActivity}
            className="h-40 aspect-auto rounded-lg border dark:border-color-dark-border-secondary border-color-border-secondary"
          />
        </RaindropClickable>

        {hasJustLiked && <LikedHeart />}
      </div>
    </WrapperDoubleClickable>
  );
};

const WaterfallButtons = ({
  waterfallPostId,
  localNumberOfLikes,
  localHasLiked,
  onClickLike,
}) => {
  return (
    <FlexRow className="justify-center" tailwindGap="gap-6">
      <RaindropButton
        title="Share"
        icon="fa-share"
        style={ButtonStyle.Icon}
        // isFluid={true}
      />

      <RaindropButton
        title="Comment"
        icon="fa-comment"
        style={ButtonStyle.Icon}
        // isFluid={true}
        to={`/raindrop/activity/comments/${waterfallPostId}`}
      />

      <RaindropButton
        title={localHasLiked ? "Unlike" : "Like"}
        icon={"fa-heart"}
        style={ButtonStyle.Icon}
        onClick={onClickLike}
        highlightIcon={localHasLiked}
        // isFluid={true}
      />
    </FlexRow>
  );
};

const AccountListElement = ({
  id,
  presignedUrl,
  username,
  setCurrentModalComponent = (x) => {},
}) => {
  const navigate = useNavigate();

  const onClick = () => {
    navigate(`/raindrop/account/${id}`);
    setCurrentModalComponent(null);
  };
  return (
    <RaindropClickable onClick={onClick}>
      <div className="flex flex-row gap-2 items-center">
        <AccountAvatar presignedUrl={presignedUrl} />

        <RaindropTextHeading1>{username}</RaindropTextHeading1>
      </div>
    </RaindropClickable>
  );
};

const LikesModal = ({
  accountObjectsLiked,
  setCurrentModalComponent = (x) => {},
}) => {
  return (
    <div className="flex flex-col  gap-4 overflow-y-auto h-96  no-scrollbar">
      <RaindropTextHeading1>Likes</RaindropTextHeading1>
      <div className="flex flex-col gap-4">
        {accountObjectsLiked.map((accountObject, index) => {
          return (
            <AccountListElement
              id={accountObject.id}
              presignedUrl={accountObject.presignedUrl}
              username={accountObject.username}
              setCurrentModalComponent={setCurrentModalComponent}
            />
          );
        })}
      </div>
    </div>
  );
};

const LikesPanel = ({
  accountObjectsLiked,
  setCurrentModalComponent = (x) => {},
}) => {
  if (accountObjectsLiked.length === 0) {
    return null;
  }

  let text =
    accountObjectsLiked.length > 1
      ? "people love this"
      : "person has loved this";

  return (
    <RaindropClickable
      onClick={() =>
        setCurrentModalComponent(
          <LikesModal
            accountObjectsLiked={accountObjectsLiked}
            setCurrentModalComponent={setCurrentModalComponent}
          />
        )
      }
    >
      <div className="flex flex-row gap-2 w-fit items-center ">
        <div className="flex flex-row">
          {accountObjectsLiked.slice(0, 3).map((accountObject, index) => {
            return (
              <div className="-ml-4 first:ml-0" key={index}>
                <AccountAvatar
                  presignedUrl={accountObject.presignedUrl}
                  isSmall={true}
                />
              </div>
            );
          })}
        </div>

        <RaindropTextParagraph>
          {accountObjectsLiked.length} {text}
        </RaindropTextParagraph>
      </div>
    </RaindropClickable>
  );
};

const WaterfallActivity = ({
  waterfallPostId,
  waterfallTitle,
  urlActivity,
  urlUser,
  urlOrganisation,
  activityDescription,
  username,
  createdAt,
  isShowingHeader = true,
  waterfallId,
  isLinkToWaterfall = true,
  numberOfLikes = 42,
  hasLiked = false,
  doShowButtons = true,
  accountObjectsLiked = [],
  setCurrentModalComponent = (x) => {},
}) => {
  const [localHasLiked, setLocalHasLiked] = useState(hasLiked);
  const [localNumberOfLikes, setLocalNumberOfLikes] = useState(numberOfLikes);
  const [hasJustLiked, setHasJustLiked] = useState(false);

  const onClickLike = () => {
    setHasJustLiked(!localHasLiked);
    setLocalHasLiked(!localHasLiked);
    setLocalNumberOfLikes(
      localHasLiked ? localNumberOfLikes - 1 : localNumberOfLikes + 1
    );

    fetchGraphQL(`
      mutation {
        waterfallPostLikeToggle(
          waterfallPostId: "${waterfallPostId}"
        ) {
          id
          numberOfLikes
          hasLiked
        }
      }
    `).catch((error) => {
      setLocalHasLiked(!localHasLiked);
      setLocalNumberOfLikes(
        localHasLiked ? localNumberOfLikes + 1 : localNumberOfLikes - 1
      );
    });
  };

  return (
    <RaindropCard>
      <div className="flex flex-col gap-4 w-full relative ">
        {isShowingHeader && (
          <WaterfallHeader
            waterfallTitle={waterfallTitle}
            urlActivity={urlActivity}
            urlUser={urlUser}
            urlOrganisation={urlOrganisation}
            username={username}
            createdAt={createdAt}
            waterfallId={waterfallId}
            isLinkToWaterfall={isLinkToWaterfall}
          />
        )}

        <WaterfallDescription activityDescription={activityDescription} />

        <WaterfallMedia
          urlActivity={urlActivity}
          hasJustLiked={hasJustLiked}
          onClickLike={onClickLike}
          setCurrentModalComponent={setCurrentModalComponent}
        />

        <LikesPanel
          accountObjectsLiked={accountObjectsLiked}
          setCurrentModalComponent={setCurrentModalComponent}
        />

        {doShowButtons && (
          <WaterfallButtons
            waterfallPostId={waterfallPostId}
            localNumberOfLikes={localNumberOfLikes}
            localHasLiked={localHasLiked}
            onClickLike={onClickLike}
          />
        )}
      </div>
    </RaindropCard>
  );
};

export default WaterfallActivity;
